import React from "react";

import Helmet from "../components/Helmet";

function DefaultLayout({ children, title }) {
    return (
        <React.Fragment>
            <Helmet title={ title }/>
            <div className="jumbotron jumbotron-fluid jumbotron-header">
                <div className="container">
                    <h1>{ title }</h1>
                </div>
            </div>
            <div className="container">
                { children }
            </div>
        </React.Fragment>
    )
}

export default React.memo(DefaultLayout);
